module.exports = __webpack_public_path__ + "img/twitter-black.c228a51f.png";